// extracted by mini-css-extract-plugin
export default {"container":"kanjiSuggestion_container__hlYvF","label":"kanjiSuggestion_label__96I61","kanji":"kanjiSuggestion_kanji__aSfz1","cancel":"kanjiSuggestion_cancel__M-N0-"};